<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @search="search" @reflash="reflash"  @del="delall" @save="sava" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li class="left" ref="left">
				<!-- 表格 -->
				<el-table
					id="xpane-0"
					:data="datajson"
					ref="singleTable"
					v-loading="loading"
					show-overflow-tooltip="true"
					border
					size="mini"
					:height="tableHeight"
					tab-click="selectInfo(0)"
					header-row-class-name="headerclass"
					@current-change="handleCurrentChanges"
					:highlight-current-row="true"
					@row-click="edits"
					@row-dblclick="openEdit"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column prop="id" v-if="false" ></el-table-column>
					<el-table-column prop="fileversion" :label="$t('getapi[3508]')" width="100">
						<template scope="scope">
							<input type="text" class="fsd clerinput" @keydown="shows($event, scope.$index)" @keyup="show($event, scope)" v-model="scope.row.fileversion" readonly />
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="uploadtime" :label="$t('getapi[6826]')" width="150"></el-table-column>
					<el-table-column show-overflow-tooltip prop="remark_show" :label="$t('getapi[6827]')" width="400"></el-table-column>
				</el-table>
				<!-- 表格 -->
			</li>

			<li class="resize" ref="resize">
				<i class="el-icon-caret-right" @click="leftt(0)"></i>
				<i class="el-icon-caret-left" @click="leftt(1)"></i>
			</li>
			<li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<div class="box" style="padding-top:20px; height: 50px;">
					<!-- 编辑弹框 -->
					<div class="bbl">
						<span>{{$t('getapi[113]')}}</span>
						<el-input  v-model="UpdateHistory.fileversion" style="width: 130px;" size="mini"></el-input>
						<span>{{$t('getapi[6828]')}}</span>
						<el-input style="width: 130px;" v-model="UpdateHistory.uploadperson" readonly></el-input>
						<span>{{$t('getapi[6829]')}}</span>
						<el-input style="width: 130px;" v-model="UpdateHistory.uploadtime" readonly></el-input>
						<!-- <el-date-picker
							v-model="UpdateHistory.uploadtime"
							type="date"
							value-format="yyyy/MM/dd HH:hh:ss"
							style="width: 130px;"
							size="mini"
						></el-date-picker> -->
					</div>
				</div>
				<el-tabs>
					<el-tab-pane :label="$t('getapi[6827]')" style="height:600px;">
						<quill-editor
							ref="text"
							v-model="UpdateHistory.remark"
							:height="tableHeight"
							class="myQuillEditor"
							:options="quillOption"
							style="height:550px;"
						/>
					</el-tab-pane>
				</el-tabs>
			</li>
		</ul>
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="16">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="SelectIndexs"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="PageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="8">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="ECNViewInfo" ref="ser" @getser="serclick"></serce>
		
	</div>
</template>

<script>
import Common from '@/components/Common';
import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { container, ImageExtend } from 'quill-image-extend-module';
Quill.register('modules/ImageExtend', ImageExtend);
import quillConfig from '@/utils/config.js';
export default {
	components: {
		quillEditor
	},
	name: 'updatehistory',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			quillOption: quillConfig,
			IsEdit: 1,
			UpdateHistory: {
				id:'',
				filecode:'',
				filename:'',
				fileversion:'',
				uploadtime:'',
				uploadperson:'',
				remark:'',
			},
			ids: '',
			rowindx: 0, //ecn实施计划负责人弹框下标
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('updatehistory'),
			SelectIndex: 1,
			SelectIndexs: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: [], // 右侧选择的数据的ID集合
			currentRow: null,
            scrollTop:0,
		};
	},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.$limits.dragControllerDiv();
		that.intidata()
		that.authority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6569]"),this.$t("getapi[12]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			if(that.userData.Login_Code=="boss"){
				that.$refs.SetBtn.SetButtonEnable('create,search,refresh,save,del');
			}
			else{
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
			}
		},
		
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.PageIndex = 1;
			this.intidata();
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('updatehistory',val)
			this.intidata();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
		},

		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
				pm = {
					row_sign: item.row_sign,
					query_Condition: item.query_Condition,
					query_sort: item.query_sort,
					query_field_type: item.Query_Field_Type,
					query_field_name: item.Query_Field_Name
				};
				parm.Param.push(pm);
			});
			that.$http.urlpost('/Sys/Currency/UpdateHistoryDataList', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
				that.loading = false;
			});
		},
		//获取详细
		getdlist(id, name, where) {
			let that = this;
			let parm = {
				Code: id
			};
			that.Type = 0;
			that.$http.urlpost('/Sys/Currency/GetUpdateHistoryInfo', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.UpdateHistory = res.DataContent;
				}
				that.authority();
			});
		},
		// 保存数据
		sava() {
			let that = this;
			that.$refs.SetBtn.SetOneBtnEnable('save', false);
			let parm = {
				Head: that.UpdateHistory
			};
			that.$http.urlpost('Sys/Currency/SaveUpdateHistory', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[284]'));
					that.intidata();
					that.getdlist(res.UniqueNum, '', '');
					that.editvisi = false;
				} else {
					that.getdlist(that.UpdateHistory.id, '', '');
				}
				that.loading = false;
			});
			that.$refs.SetBtn.SetOneBtnEnable('save', true);
		},

		//行编辑
		edits(e) {
			let that = this;
			//that.editf = true;
			that.editf = false;
			let code = e.id;
			that.getdlist(code, '', '');
		},
		// 编辑
		edit(jsd) {
			console.log("编辑:"+JSON.stringify(jsd));
			let that = this;
			that.editvisi = true;
			that.editf = false;
			that.IsEdit = 0;
			let code = jsd.row.id;
			that.getdlist(code, '', '');
		},

		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = val;
		},
		// 删除
		delf() {
			let that = this;
			let parm = {
				Code: that.UpdateHistory.id
			};
			console.log(parm);
			that.$http.urlpost('/Sys/Currency/DelUpdateHistoryByID', parm, function(res) {
				that.intidata();
				that.$message.success(that.$t('getapi[659]'));
			});
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.id + ',';
			this.delf();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8694]'), that.$t('getapi[194]'), {//'此操作将永久删除该条数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		//获取当前时间
		getnewdate() {
			var date = new Date();
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;
			var h = date.getHours();
			var mm = date.getMinutes();
			var ss = date.getSeconds();
			h = h < 10 ? '0' + h : h;
			mm = mm < 10 ? '0' + mm : mm;
			ss = ss < 10 ? '0' + ss : ss;
			return y + '/' + m + '/' + d + ' ' + h + ':' + mm + ':' + ss;
		},
		// 新增
		add() {
			let that = this;
			that.IsEdit = 1;
			that.UpdateHistory={
				id:'',
				filecode:'',
				filename:'',
				fileversion:'',
				uploadtime:'',
				uploadperson:'',
				remark:'',
			};
			this.editvisi = true;
			this.editf = true;
            that.openEdit()
			this.authority(2);
		},
		// 修改表格顺序
		opentable() {
			this.$refs.ctab.clearInputs(true);
		},
		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, '');
		},
		// 刷新
		reflash() {
			let that = this;
			that.intidata(); //刷新左边
			//刷右边
			if (!that.$limits.fnIsEmpty(that.UpdateHistory.id)) {
				that.getdlist(that.UpdateHistory.id, '', '');
			} else {
				//清空右边
				that.add();
			}
		},
	/*	//弹出框关闭前提示
		closemodel(e) {
		    let that = this;
			this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {})
				.catch(() => {});
		},*/

		leftt(e) {
			var left = document.getElementsByClassName('left');
			var mid = document.getElementsByClassName('mid');
			var Box = document.getElementsByClassName('Boxs');
			let bw = Box[0].clientWidth;
			if (e == 1) {
				left[0].style.width = '0px';
				mid[0].style.width = bw - 13 + 'px';
			} else {
				left[0].style.width = bw - 50 + 'px';
				mid[0].style.width = '0px';
			}
		},
        openEdit() {
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '0px';
            mid[0].style.width = '100%';
        },
        colseEdit(){
            let that = this
            let left = document.getElementsByClassName('left');
            let mid = document.getElementsByClassName('mid');
            let Box = document.getElementsByClassName('Boxs');
            let bw = Box[0].clientWidth;
            left[0].style.width = '100%';
            mid[0].style.width = '0px'
        },
		show(ev, row) {
			let that = this;
			that.edit(row);
		},
		shows(ev, index) {
			let that = this;
			if (ev.keyCode == 38) {
				let tds = this.datajson[index - 1];
				this.setCurrent(tds);
			}
			if (ev.keyCode == 40) {
				let tds = this.datajson[index + 1];
				this.setCurrent(tds);
			}
		},
		setCurrent(row) {
			this.$refs.singleTable.setCurrentRow(row);
		},
		handleCurrentChanges(val) {
			if (val != null) {
				let result = this.datajson.findIndex(item => item.id === val.id);
				this.indf = result;
				let fsd = document.getElementsByClassName('fsd');
				fsd[result].focus();
				this.currentRow = val;
			}
		}
	}
};
</script>
<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 20px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 5px;
		}
	}
}
.boxs {
	width: 100%;
	min-width: 840px;
}

.boxs > div {
	width: 30%;
	display: inline-block;
	white-space: nowrap;
	line-height: 30px;
}

.boxs > div > label.el-checkbox {
	min-width: 100px;
}
.box .bbl span {
	min-width: 0 !important;
}
.quill-editor.myQuillEditor {
	height: 400px;
	overflow-y: auto;
}
.bred > input {
	background: red;
	color: #fff;
}
</style>
